module.exports = __webpack_public_path__ + "media/audios/kid/lesson_7/audio43-65441c8f7a57321e7dcb84acaf2a7c0a.m4a";